/* Gallery lightbox — click any image in [data-product-gallery] to open a
   full-bleed dialog. Arrow keys + swipe navigate. Esc closes.
   Uses native <dialog> element. Fallback: does nothing if dialog unsupported. */
(function () {
  if (typeof HTMLDialogElement !== 'function') return;

  var gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;

  var images = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__image'));
  if (images.length === 0) return;

  var dialog = document.createElement('dialog');
  dialog.className = 'ra-lightbox';
  dialog.setAttribute('aria-label', 'Galería ampliada');
  dialog.setAttribute('scroll-lock', '');
  dialog.innerHTML = [
    '<button type="button" class="ra-lightbox__close" aria-label="Cerrar">&times;</button>',
    '<button type="button" class="ra-lightbox__nav ra-lightbox__nav--prev" aria-label="Anterior">&larr;</button>',
    '<button type="button" class="ra-lightbox__nav ra-lightbox__nav--next" aria-label="Siguiente">&rarr;</button>',
    '<figure class="ra-lightbox__stage">',
    '  <img class="ra-lightbox__image" alt="">',
    '  <figcaption class="ra-lightbox__counter mono"></figcaption>',
    '</figure>'
  ].join('');
  document.body.appendChild(dialog);

  var img = dialog.querySelector('.ra-lightbox__image');
  var counter = dialog.querySelector('.ra-lightbox__counter');
  var current = 0;

  function show(i) {
    current = (i + images.length) % images.length;
    var src = images[current].currentSrc || images[current].src;
    // Use widest srcset candidate if available
    var srcset = images[current].srcset;
    if (srcset) {
      var parts = srcset.split(',').map(function (s) { return s.trim().split(/\s+/); });
      var widest = parts.reduce(function (acc, p) {
        var w = parseInt(p[1], 10) || 0;
        return w > acc.w ? { w: w, url: p[0] } : acc;
      }, { w: 0, url: src });
      src = widest.url;
    }
    img.src = src;
    img.alt = images[current].alt || '';
    counter.textContent = (current + 1) + ' / ' + images.length;
  }

  function open(i) {
    show(i);
    dialog.showModal();
  }

  function close() { dialog.close(); }

  images.forEach(function (el, i) {
    el.style.cursor = 'zoom-in';
    el.addEventListener('click', function (e) {
      e.preventDefault();
      open(i);
    });
  });

  dialog.querySelector('.ra-lightbox__close').addEventListener('click', close);
  dialog.querySelector('.ra-lightbox__nav--prev').addEventListener('click', function () { show(current - 1); });
  dialog.querySelector('.ra-lightbox__nav--next').addEventListener('click', function () { show(current + 1); });

  dialog.addEventListener('click', function (e) {
    // Click on backdrop (dialog itself, not children) closes
    if (e.target === dialog) close();
  });

  dialog.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') show(current - 1);
    else if (e.key === 'ArrowRight') show(current + 1);
  });

  // Touch swipe
  var tStart = null;
  dialog.addEventListener('touchstart', function (e) {
    if (e.changedTouches && e.changedTouches[0]) tStart = e.changedTouches[0].clientX;
  }, { passive: true });
  dialog.addEventListener('touchend', function (e) {
    if (tStart === null) return;
    var dx = e.changedTouches[0].clientX - tStart;
    if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
    tStart = null;
  }, { passive: true });
})();
